import { keepPreviousData, useQuery } from "@tanstack/react-query";

import type { ListWorkflowTodosResponseJSON, ListWorkflowsResponseJSON } from "@performyard/service-contracts";

import {
	ListWorkflowTodosParams,
	ListWorkflowsParams,
	getWorkflowTodos,
	getWorkflows,
} from "../../services/defs/workflows";
import type { PYUseQueryOptions } from "../StandardQueryArguments";

export const workflowsKeys = {
	all: ["Workflows"] as const,
	list: (params?: ListWorkflowsParams) => [...workflowsKeys.all, "list", params] as const,
	todos: (params?: ListWorkflowTodosParams) => [...workflowsKeys.all, "todos", params] as const,
};

export const useWorkflows = (
	params: ListWorkflowsParams = {},
	options?: PYUseQueryOptions<ListWorkflowsResponseJSON>
) => {
	return useQuery({
		queryKey: workflowsKeys.list(params),
		queryFn: () => getWorkflows(params),
		placeholderData: keepPreviousData,
		meta: {
			errorMessage: "There was an error getting the workflows.",
		},
		...options,
	});
};

export const useWorkflowTodos = (
	params: ListWorkflowTodosParams = {},
	options?: PYUseQueryOptions<ListWorkflowTodosResponseJSON>
) => {
	return useQuery({
		queryKey: workflowsKeys.todos(params),
		queryFn: () => getWorkflowTodos(params),
		placeholderData: keepPreviousData,
		meta: {
			errorMessage: "There was an error getting the to-dos.",
		},
		...options,
	});
};
